export default "__VITE_ASSET__BnGKdccD__"